import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { SectionHeader } from '../../blocks';

// Re-exported so this dialog's files have one import for their chrome.
export { BORDER, GREY_TEXT, SectionHeader, SectionSubheader } from '../../blocks';

// The section-header treatment at title size, so the header and the label under it match.
export const ModalHeader = styled(SectionHeader)`
    font-size: 21px;
    margin-bottom: 0;
`;

export const iconCss = (color, size = 18) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${color};

    svg {
        width: ${size}px;
        height: ${size}px;
    }
`;
